import React,{Component} from 'react';
import './Contact.css';

import temp_contact_image from './temp.png';

interface Props{
    contact:any
    placeholder?:boolean
}


export default class Contact extends Component<Props>{
    
    render(){
        let image = this.props.contact.image || this.props.placeholder ? temp_contact_image : undefined;
        return (
            <div className="rt-contact">
                {
                    image &&
                    <div className="rt-contact-image">
                        <img alt={`${this.props.contact.name} profile picture`} src={image}/>
                    </div>
                }
                <div className="rt-contact-info">
                    <div className="rt-contact-name">
                        { this.props.contact.name }
                    </div>

                    {
                        this.props.contact.post &&
                        <div className="rt-contact-post">
                            { String(this.props.contact.post).split('\n').map((line: string, i: number, lines: string[]) => (
                                <React.Fragment key={i}>
                                    {line}
                                    {i < lines.length - 1 && <br />}
                                </React.Fragment>
                            )) }
                        </div>
                    }
                </div>
                <div className="rt-contact-details">
                    {
                        this.props.contact.email &&
                        <div className="rt-contact-detail">
                            <i className="fas fa-envelope"/>
                            <a className="rt-contact-detail-value" target="_blank" href={`mailto:${this.props.contact.email}`}>
                                { this.props.contact.email }
                            </a>
                        </div>
                    }
                    {
                        this.props.contact.phone &&
                        <div className="rt-contact-detail">
                            <i className="fas fa-phone-alt"/>
                            <a className="rt-contact-detail-value" target="_blank" href={`tel:${this.props.contact.phone}`}>
                                { this.props.contact.phone }
                            </a>
                        </div>
                    }                    
                </div>
            </div>
        );
    }
};

